class Animations {

    constructor() {
        this.mq = window.matchMedia("(min-width: 1025px)");
    }

    reveal(el, remove) {
        if (remove) {
            jQuery(remove).slideUp(200);
        }
        jQuery(el).slideDown(200);
    }

    hide(el) {
        jQuery(el).slideUp(200);
    }

    revealToggle(el, open, flip) {
        if (typeof open === "undefined") {
            let ele = $(el)[0];
            if (ele.isRevealed === undefined) {
                open = ele.isRevealed = true;
            } else {
                open = ele.isRevealed = !ele.isRevealed;
            }
        }
        switch (open) {
            case true:
                this.reveal(el);

                break;

            default:
                this.hide(el);
                break;
        }
        if (flip) {
            $(flip).toggleClass("flip");
        }
    }
}